import Reflux from 'reflux'
import axios from 'axios'
import _ from 'lodash'

import apiUtils from '~/helper/api.js'

import ShoppingListActions from './listActions.js'


export default class ShoppingListIngredientsStore extends Reflux.Store {
	constructor() {
		super()

		this.listenables = ShoppingListActions

		this.state = {
			categoryID: 0,
			recipeID: 0,
			// ingredientsList: [],
			shoppingList: []
		}
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	addRecipeToList() {
		const newState = _.cloneDeep(this.state.shoppingList)

		newState.push({
			quantity: 1,
			status: 'LOADING',
			recipeID: this.state.recipeID,
			ingredients: []
		})

		this.setState({ shoppingList: newState })

		this.getRecipeIngredients(this.state.recipeID)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	setCategoryID(event) {
		this.setState({ categoryID: parseInt(event.target.value, 10) })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	setRecipeID(event) {
		this.setState({ recipeID: parseInt(event.target.value || 0, 10) })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	qtyLess(recipeID) {
		const shoppingList = _.cloneDeep(this.state.shoppingList)
		const item = _.find(shoppingList, { recipeID })

		item.quantity -= 1

		this.setState({ shoppingList })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	qtyMore(recipeID) {
		const shoppingList = _.cloneDeep(this.state.shoppingList)
		const item = _.find(shoppingList, { recipeID })

		item.quantity += 1

		this.setState({ shoppingList })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	setPurchased(ingredientID) {
		const shoppingList = _.cloneDeep(this.state.shoppingList)

		_.forEach(
			shoppingList,
			(recipe) => {
				const item = _.find(recipe.ingredients, { ingredientID })

				if (typeof item !== 'undefined') {
					item.purchased = (item.purchased === 1)
						? 0
						: 1
				}
			}
		)

		this.setState({ shoppingList })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	delete(recipeID) {
		const shoppingList = _.cloneDeep(this.state.shoppingList)

		_.remove(shoppingList, { recipeID })

		this.setState({ shoppingList })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	getRecipeIngredients(recipeID) {
		// separate calls so that we can filter for the is_active=1 only
		axios.get(`${apiUtils.getApiURL()}/recipeIngredients/?filter[where][recipeID]=${recipeID}`)
			.then((responseIngredients) => {
				const newIngredients = responseIngredients.data.map((theIngredient) => {
					const returnItem = theIngredient

					returnItem.ingredient = (_.has(theIngredient, 'ingredients'))
						? theIngredient.ingredients.ingredient
						: ''
					returnItem.quantityLong = (_.has(theIngredient, 'quantities'))
						? theIngredient.quantities.quantity
						: '(unknown)'
					returnItem.quantityAbbrev = (_.has(theIngredient, 'quantities'))
						? theIngredient.quantities.quantityAbbrev
						: '(unknown)'
					returnItem.purchased = 0

					return returnItem
				})

				// flag as loaded
				const shoppingList = _.cloneDeep(this.state.shoppingList)
				const item = _.find(shoppingList, { recipeID })

				// let ingredientsList = _.cloneDeep(this.state.ingredientsList)

				item.status = 'COMPLETE'
				item.ingredients = newIngredients

				this.setState({
					// ingredientsList,
					shoppingList
				})
			})
	}
}



// WEBPACK FOOTER //
// ./src/modules/shoppingList/listStore.js